import { I18nProps, ProductsProps } from '../type'
import category_1 from '@/assets/img/product/category-1.jpg'
import service_1 from '@/assets/img/product/service-1.jpg'


import { caruscee90 } from './details/carus-cee90'
import { caruscee500 } from './details/carus-cee500'
import { ceebox251 } from './details/ce-e-box-251'
import { rpc3s125 } from './details/rpc3-s125'
import { rpc3s250 } from './details/rpc3-s250'
import { phgP510k0lnaM } from './details/phg-p510k0lna-m'
import { phgEss5l20l } from './details/phg-ess-5l-20l'
import { ces430h201 } from './details/ces430h201'
import { ces556h201 } from './details/ces556h201'
import { ceTitanV3 } from './details/ce-titan-v3'
import { ceTitanV4 } from './details/ce-titan-v4'
import { dcEvCharger } from './details/dc-ev-charger'
import { mobileEnergyStorageVehicle } from './details/mobile-energy-storage-vehicle'

export const productsEn: ProductsProps = {
  title: 'Products',
  description:
    'onverts electrical energy between forms (AC/DC) and adjusts voltage/frequency to meet device requirements. It enables efficient energy transfer in renewable systems (e.g., solar inverters), EV charging, and energy storage. Key components include rectifiers, inverters, transformers, and controllers, ensuring stable and optimized power distribution. ',
  category: [
    {
      title: 'Solar System',
      description: 'General Solar: High-performance PV solutions for various power volume.',
      cover: category_1,
    },
    {
      title: 'ESS Products & Solution',
      description: 'Stackable Block ESS: Modular design, expandable from 5kwh to 60kWh.',
      cover: category_1,
    },
    {
      title: 'DC EV Charger',
      description: 'Ultra-Fast Charging: 720kW liquid-cooling system, 200km range in 5 minutes.',
      cover: category_1,
    },
    {
      title: 'Mobile Power & EV Charger',
      description: '20ft Container: Portable ESS with 1.6MWh–3.3MWh, fast-charging for EV fleets.',
      cover: category_1,
    },
  ],
  provide: [
    {
      title: '30～40%',
      description: 'EnPact Refrigeration Cuts Supermarket And F+B Cooling Energy Use',
    },
    {
      title: '5～10%',
      description: 'EnPact Voltage Cuts Energy Use',
    },
    {
      title: 'ARK',
      description: 'ARK Monitors Energy Savings And Carbon Reductions.',
    },
    {
      title: '5～10%',
      description: 'HVAC Al Cuts Energy Use',
    },
    {
      title: '12～20%',
      description: 'EnPact Chiller Cuts AHU Energy Use',
    },
    {
      title: '20～40%',
      description: 'Enpact AC Cuts Energy Use',
    },
  ],
  services: [
    {
      title: 'Green Energy Solutions',
      cover: service_1,
    },
    {
      title: 'Environmental Construction and Hazardous Removal',
      cover: service_1,
    },
    {
      title: 'General Construction',
      cover: service_1,
    },
    {
      title: 'Flooring solutions',
      cover: service_1,
    },
    {
      title: 'Disaster Relief and Restoration',
      cover: service_1,
    },
    {
      title: 'Waterproofing',
      cover: service_1,
    },
  ],
}

export const i18nProducts: I18nProps<ProductsProps> = {
  en: productsEn,
  es: productsEn,
  cn: productsEn,
}

export const products = [caruscee90, caruscee500, ceebox251, rpc3s125, rpc3s250, phgP510k0lnaM, phgEss5l20l, ces430h201, ces556h201, ceTitanV3, ceTitanV4, dcEvCharger, mobileEnergyStorageVehicle]
